<!--打印报表弹窗-->
<template>
  <el-dialog
    title=""
    class="large-padding"
    :center="true"
    :modal="false"
    custom-class="custom-print-class"
    :visible="true"
    style="top: 100vh !important;"
  >
    <div ref="printContent" class="common-print-container">
      <div class="report-header">
        <img class="logo" :src="hotelLogo || '@/assets/print-logo.png'" alt="" srcset="" />
        <h3>
          <span class="hotelName">{{ hotelName }}</span>
        </h3>
        <h3 class="title" :class="{ 'check-out': type.includes('check_out_account_A4') }">
          {{ title }}
        </h3>
      </div>
      <div class="report-body">
        <slot name="form"></slot>
        <slot></slot>
      </div>
      <div v-if="tipText" class="desc-text">{{ tipText }}</div>
      <div class="report-bottom">
        <div v-if="isNeedAuthorise" class="authorise-sign">
          {{ $t('common.signatureOfAuthorizer') }}
        </div>
        <div class="signName" :class="{ 'check-out': type.includes('check_out_account_A4') }">
          {{ signTitle }}
        </div>
      </div>
      <el-row class="report-footer">
        <el-col :span="8">
          <div class="">{{ $t('common.handledBy') }}</div>
          <div class="font-bold">{{ name }}</div>
        </el-col>
        <el-col :span="8">
          <div class="">{{ $t('common.printTime') }}</div>
          <div class="font-bold">{{ formateTimesStamp(undefined, 'ymd hm') }}</div>
        </el-col>
        <el-col :span="8">
          <div class="">{{ $t('common.address') }}</div>
          <div class="font-bold wrap" :class="{ wrap: address && address.length > 16 }">
            {{ address }}
          </div>
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button id="printBtn" type="primary" @click="refPrint('printContent')">{{
        $t('printsettingPrint.print')
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import i18n from '@/utils/i18n';
import { mapGetters } from 'vuex';
let triggerBtn = null;
let debounce = null;
export default {
  name: 'Print',
  model: {
    prop: 'printShow',
    event: 'close',
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    printShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    isNeedAuthorise: {
      type: Boolean,
      default: false,
    },
    tipText: {
      type: String,
      default: '',
    },
    signTitle: {
      type: String,
      default: i18n.t('common.signature3'),
    },
    address: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['name', 'hotelName', 'hotelLogo']),
  },
  updated() {
    this.$nextTick(() => {
      if (this.printShow && triggerBtn) {
        if (debounce) {
          clearTimeout(debounce);
        }
        console.log('A4打印');
        debounce = setTimeout(() => {
          triggerBtn.click();
          debounce = null;
        }, 1000);
      }
    });
  },
  mounted() {
    triggerBtn = document.getElementById('printBtn');
  },
};
</script>

<style lang="scss" scoped>
@media print {
  .common-print-container {
    width: 100%;
    overflow-x: hidden;
    padding: 0;
  }
  .report-body {
    width: 100%;
  }
}
.custom-print-class {
  width: auto !important;
  position: absolute;
  top: 0;
  left: 0;
}
.logo {
  // max-width: 80%;
  // max-height: 48px;
  // width: auto;
  // height: auto;
  // object-fit: contain;
  width: 98px;
  height: 44px;
  margin-bottom: 36px;
}
.dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #2c3b4e;
  margin: 9px 4px 10px;
  border-radius: 50%;
}
.hotelName {
  font-size: 36px;
  color: #2c3b4e;
  vertical-align: super;
}
.report-header {
  font-size: 12px;
  color: #333333ff;
  padding-top: 12px;
  padding-bottom: 10px;
  .title {
    font-size: 26px;
    line-height: 1;
    padding-top: 136px;
    color: #23253a;
    padding-bottom: 50px;
    &.check-out {
      padding-top: 40px;
      padding-bottom: 24px;
    }
  }
}
.el-form-item:nth-child(3n + 1) {
  margin-left: 3%;
}
/deep/ .el-form-item__content {
  font-size: 20px;
  color: #23253a;
  font-weight: 500;
}
.report-footer {
  font-size: 14px;
  line-height: 20px;
  .font-bold {
    font-weight: bold;
    line-height: 30px;
    &.wrap {
      line-height: 20px;
      margin-top: 4px;
    }
  }
}
.signName {
  height: 140px;
  margin-top: 40px;
  &.check-out {
    height: 60px;
  }
}
.authorise-sign {
  margin-top: 60px;
}
.desc-text {
  color: #23253a;
  font-size: 14px;
  margin-top: 40px;
  padding-bottom: 40px;
}
/deep/ .report-table {
  padding-top: 30px;
  &.A4 {
    padding-top: 0;
    .cell-span {
      text-align-last: left;
      display: inline-block;
    }
  }
}
/deep/ .old-text {
  color: #9fa6ad;
  font-size: 14px;
}
</style>
